/**
 * @generated SignedSource<<acfcbcf51e2dccbff5fe2261d6a971a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUXSimplificationFeatureToggleUXSimplificationMutation$variables = {
  enabled: boolean;
};
export type useUXSimplificationFeatureToggleUXSimplificationMutation$data = {
  readonly setUxSimplificationEnabled: {
    readonly viewer: {
      readonly uxSimplificationEnabled: boolean;
    };
  } | null;
};
export type useUXSimplificationFeatureToggleUXSimplificationMutation = {
  response: useUXSimplificationFeatureToggleUXSimplificationMutation$data;
  variables: useUXSimplificationFeatureToggleUXSimplificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "enabled",
    "variableName": "enabled"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUXSimplificationFeatureToggleUXSimplificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUxSimplificationEnabled",
        "kind": "LinkedField",
        "name": "setUxSimplificationEnabled",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUXSimplificationFeatureToggleUXSimplificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUxSimplificationEnabled",
        "kind": "LinkedField",
        "name": "setUxSimplificationEnabled",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d938c2745a40ad4762bd6f7c758fdf65",
    "id": null,
    "metadata": {},
    "name": "useUXSimplificationFeatureToggleUXSimplificationMutation",
    "operationKind": "mutation",
    "text": "mutation useUXSimplificationFeatureToggleUXSimplificationMutation(\n  $enabled: Boolean!\n) {\n  setUxSimplificationEnabled(enabled: $enabled) {\n    viewer {\n      uxSimplificationEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f80bfe4f1df77f84d3ba96891b401035";

export default node;
